import { Reducer } from 'redux';

import { defaultProject } from '../services/project';
import { ActionTypes } from '../types/action-types';
import { ActionObject, IProject } from '../types/project';

export default ((state = defaultProject(), action: ActionObject): IProject => {
  switch (action.type) {
    case ActionTypes.PROJECT_SELECTED:
      return {
        ...state,
        id: action.id,
        name: action.name,
        auth: action.auth,
        integrations: action.integrations,
        isActive: action.isActive
      };

  }
  return {...state};
}) as Reducer<IProject>;



// WEBPACK FOOTER //
// ./src/sub-projects/tenant/reducers/project.ts